/**
 * EL REGISTRO PUBLICO NO DICE "LISTO" SI NO SE GUARDO (Ares #38558; medido por P en #38556).
 *
 * QUE PASABA. Dos fallas calladas que se encadenaban en #/onboard/{token}:
 *   1. el GET del enlace con 404/410 (enlace vencido o que no existe) armaba un borrador falso "pending" y la persona
 *      llenaba todo el formulario sobre un enlace que no sirve;
 *   2. al confirmar, un 404/401/5xx no era 400 ni "sin red": se pintaba el cierre de siempre ("Listo, ya tengo todo")
 *      sin que nada se hubiera guardado.
 * En octubre nadie cayo en eso (0 de 4 enlaces, 0 de 17 envios fallaron): es una falla latente.
 *
 * LA REGLA. El enlace: 2xx sirve; 404/410 vencido (se dice y no se arma borrador); sin red o 5xx, se trabaja con el
 * borrador del celular. El envio: solo un 2xx sigue al cierre; 400 lo maneja la vista (vuelve al paso del dato
 * rechazado); 404/410 = el enlace vencio; cualquier otro = no se guardo, intenta otra vez, el borrador queda a salvo.
 * Sin DOM: lo prueba scripts/check-envio-registro.mjs.
 *
 * @module application/onboarding/envioDelRegistro
 */

export const ENLACE_VENCIDO = 'Este enlace ya no sirve. Pide uno nuevo a Nexo.';
export const NO_SE_GUARDO = 'No pudimos guardar tu registro. Tus datos quedaron en este celular; intenta otra vez en un rato.';

const vencido = (s) => s === 404 || s === 410;

/** El GET del enlace: 'ok' | 'vencido' | 'sin_red' | 'error'. status null/0 = no hubo respuesta. */
export function leerSesionDelEnlace(status) {
  const s = Number(status);
  if (!s) return 'sin_red';
  if (s >= 200 && s < 300) return 'ok';
  if (vencido(s)) return 'vencido';
  return 'error';
}

/** El POST de confirmar ({status} o null): 'guardado' | 'rechazo' | 'enlace_vencido' | 'no_guardado' | 'sin_red'. */
export function desenlaceDelEnvio(r) {
  if (!r) return 'sin_red';
  const s = Number(r.status);
  if (s >= 200 && s < 300) return 'guardado';
  if (s === 400) return 'rechazo';
  if (vencido(s)) return 'enlace_vencido';
  return 'no_guardado';
}
